import { CategoryState, initialCategoryState } from './category.reducer';
import { AttributeState, initialAttributeState } from './attribute.reducer';
import { ComponentsState, initialComponentsState } from './component.reducer';
import { initialWebshopState, WebshopState } from './webshop.reducer';
import { FilterState, initialFilterState } from './filter.reducer';
import { CustomerState, initialCustomerState } from './customer.reducer';
import { CompanyState, initialCompanyState } from './company.reducer';
import { initialProductState, ProductState } from '@store/reducers/product.reducer';
import { initialPageState, PageState } from './page.reducer';

export enum StateProperty {
  WEBSHOPS = 'webshops',
  PHOTO_GALLERIES = 'photoGalleries',
  CUSTOMERS = 'customers',
  COMPANIES = 'companies',
  CATEGORIES = 'categories',
  ATTRIBUTES = 'attributes',
  PRODUCTS = 'products',
  PAGES = 'pages',
  FILTERS = 'filters',
  SERVICE_STATUS = 'serviceStatus',
  COMPONENTS = 'components'
}

export interface SharedState {
  loaded: boolean;
  isLoading: boolean;
  error: string;
}

export interface State {
  webshops: WebshopState,
  filters: FilterState,
  customers: CustomerState,
  companies: CompanyState,
  categories: CategoryState,
  attributes: AttributeState,
  products: ProductState,
  pages: PageState,
  components: ComponentsState
}

export const initialState: State = {
  webshops: initialWebshopState,
  filters: initialFilterState,
  customers: initialCustomerState,
  companies: initialCompanyState,
  categories: initialCategoryState,
  attributes: initialAttributeState,
  products: initialProductState,
  pages: initialPageState,
  components: initialComponentsState
}
